<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{ $t('AddressInterventions') }}</h1>
          <h2 class="page-subtitle">{{ $t('Total') }} : {{ totalCount }}</h2>
        </div>
        <b-button variant="primary" @click="clickOnCreateBtn">
          <plus-icon size="18" class="mr-1"/>
          {{ $t('Create') }} {{ $t('addressIntervention') }}
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableAddressIntervention"
          identifier="B122TableAddressIntervention"
          init-b122-table-url="/addressIntervention/initB122Table"
          get-b122-table-results-url="/addressIntervention/getB122TableResults"
          :fields="tableFields"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        >

          <template #cell(tenant)="data">
            <b-link v-if="data.item.tenant != null" :to="{name: 'ClientShow', params:{clientId: data.item.tenant.id}}" class="force-link">
              {{data.item.tenant.name}}
            </b-link>
          </template>
          <template #cell(owner)="data">
            <b-link v-if="data.item.owner != null" :to="{name: 'ClientShow', params:{clientId: data.item.owner.id}}" class="force-link">
              {{data.item.owner.name}}
            </b-link>
          </template>
          <template #cell(agency)="data">
            <b-link v-if="data.item.agency != null" :to="{name: 'ClientShow', params:{clientId: data.item.agency.id}}" class="force-link">
              {{data.item.agency.name}}
            </b-link>
          </template>

          <template #cell(address)="data">
            <div>
             {{data.item.address}}
            </div>
            <div>
              {{data.item.additionalAddress}}
            </div>
          </template>

        </b122-table>
      </b-card>
    </b-container>
    <AddressIntervention-delete-modal :selectedAddressIntervention="ui.selectedAddressIntervention" @didDeleteAddressIntervention="didDeleteAddressIntervention()"></AddressIntervention-delete-modal>
  </div>
</template>

<script>

import B122Table from "../../components/b122/B122Table";
import AddressInterventionDeleteModal from "./AddressInterventionDeleteModal";
import {dateUtils} from "../../mixins/utils";
export default {

  name: 'AddressInterventionIndex',

  mixins: [dateUtils],

  components: {
    B122Table,
    AddressInterventionDeleteModal
  },

  data() {
    return {

      totalCount: 0,

      tableFields: [
        {
          label: "",
          key: "show",
          sortable: false
        },
        {
          label: this.$i18n.t('addressIntervention.address'),
          key: "address",
          sortKey:"address",
          sortable: true
        },
        {
          label: this.$i18n.t('addressIntervention.postalCode'),
          key: "postalCode",
          sortKey:"postalCode",
          sortable: true
        },
        {
          label: this.$i18n.t('addressIntervention.city'),
          key: "city",
          sortKey:"city",
          sortable: true
        },
        {
          label: this.$i18n.t('Tenant'),
          key: "tenant",
          sortable: false,
          formatter: function (value) {
            return !!value
          }
        },
        {
          label: this.$i18n.t('Owner'),
          key: "owner",
          sortable: false,
          formatter: function (value) {
            return !!value
          }
        },
        {
          label: this.$i18n.t('Agency'),
          key: "agency",
          sortable: false,
          formatter: function (value) {
            return !!value
          }
        },
        {
          label: "",
          key: "actions"
        }
      ],
      ui: {
        selectedAddressIntervention: null
      }
    }
  },

  methods: {

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'AddressInterventionCreate'
      })
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'AddressInterventionShow',
        params: {
          addressInterventionId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'AddressInterventionEdit',
        params: {
          addressInterventionId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selectedAddressIntervention = row.item
      this.$bvModal.show('addressIntervention-delete-modal')
    },

    didDeleteAddressIntervention() {
      this.ui.selectedAddressIntervention = null;
      this.$refs.B122TableAddressIntervention.refreshTable()
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/addressIntervention/AddressInterventionIndex.vue